import { render, staticRenderFns } from "./ConformityTable.vue?vue&type=template&id=9055bfee&scoped=true&"
import script from "./ConformityTable.vue?vue&type=script&lang=js&"
export * from "./ConformityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055bfee",
  null
  
)

export default component.exports